
const OurStudentsSection = () => {
  return (
    <div className="py-20 container">
        <p className="text-primary mb-3 font-semibold">Our Clients <span className="text-secondary">Trust us</span></p>
        <h1 className="text-4xl font-semibold -tracking-[0.02em] mb-4">When Do You Need Personal or Organizational Consultation?</h1>
        <p className="mb-3 text-[#808080]">Consultation is essential when facing challenges in decision-making, improving processes, or achieving specific goals within your personal or organizational framework.
        </p>
        <p className="text-[#808080]">
        It helps identify opportunities, address inefficiencies, and create tailored strategies for growth and success.</p>
    </div>
  )
}

export default OurStudentsSection